import React from 'react';
import { SUPPORT_EMAIL } from '../data/content';
export function Footer() {
  return <footer className="w-full bg-plum-700 px-5 py-12" data-id="element-77" data-mp="3gezev8fo7z39">
      <div className="mx-auto max-w-3xl space-y-4 text-center text-sm leading-relaxed text-cream-200/80" data-id="element-78" data-mp="3ggk8mvu5ve02">
        <p className="font-medium text-cream-100" data-id="element-79" data-mp="32lrkxa44arie">
          © 2025 PUERTO SERENO — Todos los derechos reservados.
        </p>
        <p data-id="element-80" data-mp="3ufa4671c15mb">
          Consultas:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="text-rose-200 underline decoration-rose-300/50 underline-offset-4 transition-colors duration-150 hover:text-rose-100" data-id="element-81" data-mp="3ugbshd7czolz">
            {SUPPORT_EMAIL}
          </a>
        </p>
        <p data-id="element-82" data-mp="3qd6spieny111">
          Este material ha sido creado con fines informativos y educativos. No reemplaza la atención
          de un profesional de salud mental. Si tu situación implica riesgo físico inmediato,
          contacta a los servicios de emergencia de tu país.
        </p>
      </div>
    </footer>;
}